import React from 'react'

export default function NewBooking() {
    return (
        <div>
            
        </div>
    )
}
